import ProductPageLayout from "@/components/ProductPageLayout";
import kaihtimet from "@/assets/kaihtimet.png?format=webp&w=800";

const KaihdinAsennus = () => (
  <ProductPageLayout title="Kaihdin asennus" metaDescription="Ammattitaitoinen kaihtimien asennus Keski-Uudellamaalla. Pimennys- ja älykaihtimet, moottoriohjatut kaihtimet, hyttyssuojat." image={kaihtimet} partner="solar" path="/kaihdin-asennus" alternatePath="/en/blind-installation">
    <p className="text-muted-foreground leading-relaxed">
      Kaihtimet ovat yksi suosituimmista ikkunaratkaisuista – ja syystä. Tarjoamme pimennys- ja älykaihtimet, 
      moottoriohjatut kaihtimet sekä hyttyssuojat. Asennamme ammattitaidolla ja huolellisuudella.
    </p>
    <h2 className="font-display text-2xl font-bold mt-8 mb-3">Miksi valita ammattiasennus?</h2>
    <ul className="space-y-2 text-muted-foreground">
      <li>✓ Tarkka mittaus varmistaa täydellisen istuvuuden</li>
      <li>✓ Siisti ja nopea asennus ilman ikkunakarmien vaurioita</li>
      <li>✓ Oikea kiinnitystapa jokaiseen ikkunatyyppiin</li>
      <li>✓ Solar Kaihtimen takuutuotteet</li>
    </ul>
    <h2 className="font-display text-2xl font-bold mt-8 mb-3">Palvelualue</h2>
    <p className="text-muted-foreground leading-relaxed">
      Tarjoamme kaihdin asennusta koko Keski-Uudenmaan alueella: Hyvinkää, Järvenpää, Kerava, Mäntsälä, Nurmijärvi, Pornainen ja Tuusula. 
      Tutustu <a href="https://solar.fi" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 text-foreground">Solar Kaihtimen valikoimaan</a> ja 
      ota yhteyttä niin autamme löytämään oikean ratkaisun.
    </p>
  </ProductPageLayout>
);

export default KaihdinAsennus;
